import AccommodationIndividualSelectRoomTile from 'components/AccommodationKit/AccommodationIndividualSelectRoom/AccommodationIndividualSelectRoomTile'
import AccommodationIndividualSelectRoomTileDetails from 'components/AccommodationKit/AccommodationIndividualSelectRoom/AccommodationIndividualSelectRoomTileDetails'
import AccommodationIndividualSelectRoomOptions from 'components/AccommodationKit/AccommodationIndividualSelectRoom/AccommodationIndividualSelectRoomOptions'
import AccommodationRoomTileImage from 'components/AccommodationKit/AccommodationRoomTileImage'
import CardCarousel from 'LuxKit/Carousel/CardCarousel'
import { rem } from 'polished'

import type { OfferPageRoom } from 'contexts/OfferPage/offerPageStateReducer'
import type { RoomRateViews } from './singlePropertyUtils'
import PropertyIndividualRoomAnytimeRateOption from './PropertyIndividualRoomAnytimeRateOption'
import PropertyIndividualRoomSelectRoomOption from './PropertyIndividualRoomSelectRoomOption'

interface Props {
  optionVariant: 'stacked' | 'carousel'
  roomOption: RoomRateViews
  currentRoomTypeId?: string
  currentOptionId?: string
  occupancyRoom: OfferPageRoom
  duration: number
  noRateSelectionEnabled?: boolean
  onSelectRate: (roomTypeId: string, optionId: string | undefined) => void
}

function PropertyIndividualRoomSelectRoom(props: Props) {
  const {
    optionVariant,
    roomOption,
    currentRoomTypeId,
    currentOptionId,
    occupancyRoom,
    duration,
    noRateSelectionEnabled = false,
    onSelectRate,
  } = props

  const isCurrentSelection = roomOption.roomId === currentRoomTypeId
  const carouselWidth = roomOption.rates.length > 1 ? rem(300) : '100%'

  const optionTiles = roomOption.rates.map((rate) => (
    <PropertyIndividualRoomSelectRoomOption
      key={rate.optionId}
      rate={rate}
      isSelected={isCurrentSelection && rate.optionId === currentOptionId}
      optionVariant={optionVariant}
      occupancyRoom={occupancyRoom}
      onSelect={(optionId) => onSelectRate(roomOption.roomId, optionId)}
    />
  ))

  const noRateOption = <PropertyIndividualRoomAnytimeRateOption
    propertyRoom={roomOption.propertyRoom}
    isSelected={isCurrentSelection}
    optionVariant={optionVariant}
    duration={duration}
    onSelect={() => onSelectRate(roomOption.roomId, currentOptionId)}
  />

  return (
    <AccommodationIndividualSelectRoomTile roomPackage={roomOption.propertyRoom} isCurrentSelection={isCurrentSelection}>
      <AccommodationRoomTileImage roomPackage={roomOption.propertyRoom} showBookmark={false} />
      <AccommodationIndividualSelectRoomTileDetails roomPackage={roomOption.propertyRoom} />
      <AccommodationIndividualSelectRoomOptions hasOptions>
        {optionVariant === 'carousel' && (
          <CardCarousel width={carouselWidth} gutterSize={20} gap={12} snap="start">
            {noRateSelectionEnabled && roomOption.rates.length === 0 && noRateOption}
            {optionTiles}
          </CardCarousel>
        )}
        {optionVariant === 'stacked' && <>
          {noRateSelectionEnabled && roomOption.rates.length === 0 && noRateOption}
          {optionTiles}
        </>}
      </AccommodationIndividualSelectRoomOptions>
    </AccommodationIndividualSelectRoomTile>
  )
}

export default PropertyIndividualRoomSelectRoom
